import { useEffect, useState } from 'react';

import { cloneDeep } from 'lodash';

import { useLazyFertPredictionTech } from '@/services/fresh-shipment/hooks';
import { TOA_GetFreshShipmentFertList } from '@/types.gql';

export const useFertilizationData = (
  fertilizationListData: TOA_GetFreshShipmentFertList[] | undefined,
) => {
  const [fertilizations, setFertilizations] = useState<
    TOA_GetFreshShipmentFertList[]
  >([]);

  const getFertPredictionTech = useLazyFertPredictionTech();

  useEffect(() => {
    if (!fertilizationListData) return;
    let cancelled = false;

    const updateFertilizationData = async () => {
      const updatedFertilizationData = await Promise.all(
        cloneDeep(fertilizationListData).map(async (item) => {
          const updatedItem = {
            ...item,
          };

          if (item.predictedBy === null) {
            const result = await getFertPredictionTech(item.fertilizationId);
            if (result?.name) {
              updatedItem.predictedBy = result.name;
            }
          }

          return updatedItem;
        }),
      );

      if (cancelled) return;

      const sortedData = updatedFertilizationData.sort((a, b) => {
        if (!a.predictedBy && b.predictedBy) return -1;
        if (a.predictedBy && !b.predictedBy) return 1;
        return 0;
      });
      setFertilizations(sortedData);
    };

    updateFertilizationData();
    return () => {
      cancelled = true;
    };
  }, [fertilizationListData, getFertPredictionTech]);

  return fertilizations;
};
